/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserPreferencesDto
 */
export interface UpdateUserPreferencesDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPreferencesDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserPreferencesDto
     */
    emailOnFormCreated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserPreferencesDto
     */
    emailOnFormSubmitted?: boolean;
    /**
     * Whether to receive email when someone else updates a form the user created
     * @type {boolean}
     * @memberof UpdateUserPreferencesDto
     */
    emailOnFormUpdated?: boolean;
    /**
     * Whether to receive email when someone comments on a form the user created
     * @type {boolean}
     * @memberof UpdateUserPreferencesDto
     */
    emailOnCommentAdded?: boolean;
    /**
     * Active signing provider. Only applied if the user has an admin role.
     * @type {string}
     * @memberof UpdateUserPreferencesDto
     */
    signingProvider?: UpdateUserPreferencesDtoSigningProviderEnum | null;
}


/**
 * @export
 */
export const UpdateUserPreferencesDtoSigningProviderEnum = {
    Mock: 'mock',
    Signius: 'signius'
} as const;
export type UpdateUserPreferencesDtoSigningProviderEnum = typeof UpdateUserPreferencesDtoSigningProviderEnum[keyof typeof UpdateUserPreferencesDtoSigningProviderEnum];


/**
 * Check if a given object implements the UpdateUserPreferencesDto interface.
 */
export function instanceOfUpdateUserPreferencesDto(value: object): value is UpdateUserPreferencesDto {
    return true;
}

export function UpdateUserPreferencesDtoFromJSON(json: any): UpdateUserPreferencesDto {
    return UpdateUserPreferencesDtoFromJSONTyped(json, false);
}

export function UpdateUserPreferencesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserPreferencesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'emailOnFormCreated': json['emailOnFormCreated'] == null ? undefined : json['emailOnFormCreated'],
        'emailOnFormSubmitted': json['emailOnFormSubmitted'] == null ? undefined : json['emailOnFormSubmitted'],
        'emailOnFormUpdated': json['emailOnFormUpdated'] == null ? undefined : json['emailOnFormUpdated'],
        'emailOnCommentAdded': json['emailOnCommentAdded'] == null ? undefined : json['emailOnCommentAdded'],
        'signingProvider': json['signingProvider'] == null ? undefined : json['signingProvider'],
    };
}

export function UpdateUserPreferencesDtoToJSON(json: any): UpdateUserPreferencesDto {
    return UpdateUserPreferencesDtoToJSONTyped(json, false);
}

export function UpdateUserPreferencesDtoToJSONTyped(value?: UpdateUserPreferencesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'emailOnFormCreated': value['emailOnFormCreated'],
        'emailOnFormSubmitted': value['emailOnFormSubmitted'],
        'emailOnFormUpdated': value['emailOnFormUpdated'],
        'emailOnCommentAdded': value['emailOnCommentAdded'],
        'signingProvider': value['signingProvider'],
    };
}

